<template>
    <div>
    </div>

</template>

<script>

    export default {
        props: {
            params: {}
        },
        data: function () {
            return {
            };
		},
		methods: {
            async save()
            {
                return {
                }
            },
            async load(data)
            {
            }
		},
		mounted: function () {
            if (this.params)
                this.load(this.params)
		},
    }


</script>